import { Image } from "@frontend/core";

export class LickertQuestion {
    constructor (
        public id : number,
        public text : string,
        public context : string,
        public feedback : string,
        public help : string,
        public label : string,
        public question_id : number, // this is the backend "Question" type, not the backend "MultipleChoiceQuestion" type
        public hide_context : boolean, // if the survey by default requires that we show snapshot context, we will hide the snapshot context for this question
        public hide_raters : boolean, // if the survey by default requires that we show multi-raters, we will hide the raters for this question
        public visualisation : {type:string},
        public survey_id : number,
        public anchor_set: string[],
        public images : Image[],
    ){}
}